import 'aos/dist/aos.css';
import { Trans, useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import React, { useState } from "react";
import CallToActionSmall from "../components/v2/call-to-action-sm";
import CardWithIcon from "../components/v2/cards/card-with-icon";
import PartnersForm from "../components/v2/form/partner-form";
import {
    ImproveCustomer,
    MwSmallIcon,
    Scalable,
    Training
} from "../components/v2/icons";
import "../styles/scss/partner.module.scss";
import '../styles/scss/comparison.module.scss';
import '../styles/scss/customer.module.scss';
import "../styles/scss/_move-to-middleware.module.scss";

const Dialog = dynamic(() => import('../components/v2/dialog'), {
    ssr: false,
})

const iconMap: { [key: string]: React.ReactNode } = {
    Scalable: <Scalable/>,
    Training: <Training/>,
    ImproveCustomer: <ImproveCustomer/>
};

const Partner = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation('common');
    const partnersData = t('partners', { returnObjects: true, defaultValue: {} }) as any;

    const heroData = partnersData?.hero || {};
    const whyPartnerData = partnersData?.whyPartner || {};
    const partnerBenefitsData = partnersData?.partnerBenefits || {};
    const ourPartnersData = partnersData?.ourPartners || {};
    const ctaData = partnersData?.cta || {};

    const whyPartnerCards = Array.isArray(whyPartnerData?.cards) ? whyPartnerData.cards : [];
    const partnerOptions = Array.isArray(partnerBenefitsData?.options) ? partnerBenefitsData.options : [];
    const partnerLogos = Array.isArray(ourPartnersData?.logos) ? ourPartnersData.logos : [];

    const isOpenDialog = () => {
        setIsOpen(true)
    }
    return <>


        <div className="partner-page">
            <div className={"hero-section"}>
                <div className={"container"}>
                    <h1>
                    <Trans 
                  i18nKey="partners.hero.title"
                  components={{
                    highlight: <span className="text-gradient" />
                  }}
                />
                    
                    </h1>
                    <p>{String(heroData?.description ?? '')}</p>
                    <p className={"ahref-btn primary"} onClick={() => isOpenDialog()}>{String(heroData?.cta?.text ?? '')}</p>
                    
                </div>
            </div>

            <section className={'mw-card-with-icon product-page'}>
                <div className={'container'}>
                    <div className={'section-tag testimonial pd-right'}><MwSmallIcon/>{String(whyPartnerData?.sectionTag ?? '')}</div>
                    <h2>
                        {String(whyPartnerData?.titlePrefix ?? '')}
                        <span className={"text-gradient"}>{String(whyPartnerData?.titleHighlight ?? '')} </span>
                        {String(whyPartnerData?.titleSuffix ?? '')}
                    </h2>
                    <div className={'card-items'}>
                        <div className={'d-flex card-items'}>
                            {whyPartnerCards.map((card: any, index: number) => (
                                <CardWithIcon 
                                    key={index}
                                    icon={iconMap[String(card?.icon ?? '')] || null}
                                    title={String(card?.title ?? '')}
                                    description={String(card?.description ?? '')}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className={"move-to-middleware"}>
                <div className={"container"}>
                    <div className={"mw-feature"}>
                        <div className={"d-flex"}>
                            <div className={"left-block"}>
                                <div className={"left-sticky"}>
                                    <div className={'section-tag testimonial'}><MwSmallIcon/> {String(partnerBenefitsData?.sectionTag ?? '')}</div>
                                    <h2>
                                        {Array.isArray(partnerBenefitsData?.titleParts) ? partnerBenefitsData.titleParts.map((part: any, index: number) => (
                                            <React.Fragment key={index}>
                                                {part.isLineBreak && <br/>}
                                                {part.isGradient ? (
                                                    <span className={"text-gradient"}>{String(part?.text ?? '')}</span>
                                                ) : (
                                                    <>{String(part?.text ?? '')}</>
                                                )}
                                            </React.Fragment>
                                        )) : null}
                                    </h2>
                                    <img 
                                        src={String(partnerBenefitsData?.image?.src ?? '')}
                                        alt={String(partnerBenefitsData?.image?.alt ?? '')} 
                                        width={String(partnerBenefitsData?.image?.width ?? '')} 
                                        height={String(partnerBenefitsData?.image?.height ?? '')}
                                    />
                                </div>
                            </div>
                            <div className={"right-block"}>
                                {partnerOptions.map((option: any, index: number) => (
                                    <div key={index} className={"view-card"}>
                                        <img 
                                            src={String(option?.image?.src ?? '')} 
                                            alt={String(option?.image?.alt ?? '')} 
                                            width={option?.image?.width ?? 100} 
                                            height={option?.image?.height ?? 100} 
                                        />
                                        <h3>{String(option?.title ?? '')}</h3>
                                        <p>{String(option?.description ?? '')}</p>
                                    </div>
                                ))}
                                <div className={"partner-cta"}>
                                    <p>{String(partnerBenefitsData?.cta?.title ?? '')}</p>
                                    <p className={"ahref-btn primary"} onClick={() => isOpenDialog()}>
                                        {String(partnerBenefitsData?.cta?.button ?? '')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className={"customer-trust"}>
                <div className={"container"}>
                    <div className={'section-tag testimonial pd-right'}><MwSmallIcon/> {String(ourPartnersData?.sectionTag ?? '')}</div>
                    <h2>
                        {String(ourPartnersData?.titlePrefix ?? '')}
                        <span className={"text-gradient"}> {String(ourPartnersData?.titleHighlight ?? '')} </span>
                        {String(ourPartnersData?.titleSuffix ?? '')}
                    </h2>

                    <div className={"our-trusted"}>
                        <div className={"d-flex"}>
                            {partnerLogos.map((logo: any, index: number) => (
                                <img
                                    key={index}
                                    src={String(logo?.src ?? '')}
                                    alt={String(logo?.alt ?? '')}
                                    width={logo?.width ?? 200}
                                    height={logo?.height ?? 200}
                                />
                            ))}
                        </div>

                    </div>

                </div>
            </div>

            <CallToActionSmall title={String(ctaData?.title ?? '')}/>

            <Dialog
                isOpen={isOpen}
                position={"center"}
                contentClassName={"partner-page"}
                onClose={() => {
                    setIsOpen(false);
                }}
                size={"sm"}
                verticalCenter={true}
            >
                <PartnersForm/>
            </Dialog>
        </div>
    </>
}

export default Partner